// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetBusinessesRequestModel from '../../model/get-businesses-request-model';
import GetBusinessesRequestDTO from '../dto/get-businesses-request-dto';
import dtoSchema from '../schemas/get-businesses-request-schema';

export default abstract class GetBusinessesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetBusinessesRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.id = data.id;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetBusinessesRequestDTO>): GetBusinessesRequestModel;
  static toModel(dto: DeepPartial<GetBusinessesRequestDTO> | undefined | null): GetBusinessesRequestModel | undefined;
  static toModel(dto: DeepPartial<GetBusinessesRequestDTO> | undefined | null): GetBusinessesRequestModel | undefined {
    return dto ? new GetBusinessesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetBusinessesRequestModel> | GetBusinessesRequestModel): GetBusinessesRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      id: unwrapped.id,
      searchCriteria: unwrapped.searchCriteria,
    } as GetBusinessesRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetBusinessesRequestModel, can not map to GetBusinessesRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
